/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Id_Mismatch_ErrorInputs */

const en_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whoops! It appears your order ID doesn't match your purchase receipt. Please contact Brave support.`)
};

const id_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aduh! Tampaknya ID pesanan Anda tidak cocok dengan kuitansi pembelian Anda. Silakan hubungi dukungan Brave.`)
};

const ms_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wah-oh! Nampaknya ID pesanan anda tidak sepadan dengan resit pembelian anda. Sila hubungi sokongan Brave.`)
};

const ca_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaja! Sembla que l'ID de la teva comanda no coincideix amb el teu rebut de compra. Si us plau, contacta amb el suport tècnic de Brave.`)
};

const cs_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jejda! Vaše ID objednávky neodpovídá potvrzení o koupi. Kontaktujte podporu Brave.`)
};

const da_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hovsa! Det ser ud til, at dit ordre-ID ikke matcher din købskvittering. Kontakt venligst Brave support.`)
};

const de_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upps! Es scheint, dass Ihre Bestell-ID nicht mit Ihrem Kaufbeleg übereinstimmt. Bitte kontaktieren Sie den Brave-Support.`)
};

const et_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oih! Tundub, et teie tellimuse ID ei ühti teie ostuarvega. Võtke ühendust Brave toe teenusega.`)
};

const es_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Ups! Parece que tu ID de pedido no coincide con tu recibo de compra. Por favor, ponte en contacto con el soporte de Brave.`)
};

const fr_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il semble que votre numéro de commande ne corresponde pas à votre reçu d’achat. Veuillez contacter l’assistance Brave.`)
};

const hr_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Čini se da se vaš ID narudžbe ne podudara s vašim računom za kupnju. Molimo obratite se Brave podršci.`)
};

const it_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ops! Sembra che il tuo ID ordine non corrisponda alla tua ricevuta di acquisto. Contatta il supporto Brave.`)
};

const lv_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Izskatās, ka jūsu pasūtījuma ID neatbilst jūsu pirkuma kvīts informācijai. Lūdzu, sazinieties ar Brave atbalstu.`)
};

const lt_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oi! Panašu, kad jūsų užsakymo ID nesutampa su jūsų pirkimo kvitu. Kreipkitės į Brave palaikymą.`)
};

const hu_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppá! Úgy tűnik, hogy a rendelési azonosítója nem egyezik a vásárlási nyugtájával. Kérjük, vegye fel a kapcsolatot a Brave támogatással.`)
};

const nl_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oeps! Het lijkt erop dat je bestelnummer niet overeenkomt met je aankoopbewijs. Neem contact op met Brave support.`)
};

const nb_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oi! Det ser ut som bestillingsnummeret ditt ikke samsvarer med kjøpskvitteringen din. Ta kontakt med Braves brukerstøtte for å få hjelp.`)
};

const pl_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Wygląda na to, że identyfikator zamówienia nie pasuje do twojego dowodu zakupu. Skontaktuj się z pomocą techniczną Brave.`)
};

const pt_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ops! Parece que o ID do seu pedido não corresponde ao recibo de compra. Por favor, contate o suporte do Brave.`)
};

const ro_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hopa! Se pare că ID-ul comenzii dvs. nu se potrivește cu chitanța de achiziție. Vă rugăm să contactați asistența Brave.`)
};

const sk_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Zdá sa, že ID vašej objednávky nezodpovedá dokladu o nákupe. Kontaktujte prosím podporu Brave.`)
};

const sl_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ups! Videti je, da vaše naročilo ID ne ustreza vašemu potrdilu o nakupu. Prosimo, obrnite se na podporo Brave.`)
};

const fi_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hups! Näyttää siltä, että tilaustunnuksesi ei vastaa ostoskuittiasi. Ota yhteyttä Brave-tukeen.`)
};

const sv_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oj! Det verkar som om ditt order-ID inte matchar ditt kvitto. Vänligen kontakta Brave support.`)
};

const vi_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ối! Có vẻ như ID đơn hàng của bạn không khớp với biên nhận mua hàng của bạn. Vui lòng liên hệ hỗ trợ Brave.`)
};

const tr_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüh! Sipariş kimlik numaranız satın alma faturası ile uyuşmuyor gibi görünüyor. Lütfen Brave destek ile iletişime geçin.`)
};

const el_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ορίστε! Φαίνεται ότι ο αριθμός της παραγγελίας σας δεν ταιριάζει με την απόδειξη αγοράς σας. Παρακαλούμε επικοινωνήστε με την υποστήριξη του Brave.`)
};

const bg_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Изглежда, че номерът на вашата поръчка не съответства на вашата покупна разписка. Моля, свържете се с поддръжка на Brave.`)
};

const ru_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Похоже, ваш ID заказа не совпадает с вашей квитанцией о покупке. Пожалуйста, свяжитесь с поддержкой Brave.`)
};

const sr_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Чини се да ваш ID наруџбине не одговара вашем рачуну о куповини. Молимо контактирајте Brave подршку.`)
};

const uk_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упс! Схоже, ваш ідентифікатор замовлення не відповідає вашому чеку про покупку. Будь ласка, зверніться до служби підтримки Brave.`)
};

const ka_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ვერა! როგორც ჩანს, თქვენი შეკვეთის ID თქვენს შესყიდვის ქვითართან არ ემთხვევა. გთხოვთ დაუკავშირდეთ Brave-ის მხარდაჭერას.`)
};

const hi_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षमा करें! ऐसा प्रतीत होता है कि आपका ऑर्डर आईडी आपकी खरीदी रसीद से मेल नहीं खाता है। कृपया Brave सपोर्ट से संपर्क करें।`)
};

const th_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อุ๊ปส์! ดูเหมือนว่าหมายเลขคำสั่งซื้อของคุณไม่ตรงกับใบเสร็จการซื้อของคุณ โปรดติดต่อฝ่ายสนับสนุนของ Brave`)
};

const ko_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`죄송합니다! 주문 ID가 구매 영수증과 일치하지 않는 것 같습니다. Brave 지원에 문의해 주세요.`)
};

const zh_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`糟糕！您的订单 ID 似乎与购买收据不符。请联系 Brave 支持。`)
};

const zh_tw_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哎呀！您的訂單編號似乎與購買收據不符。請聯絡 Brave 客服支援。`)
};

const ja_order_id_mismatch_error = /** @type {(inputs: Order_Id_Mismatch_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申し訳ありませんが、ご注文IDが購入領収書と一致しませんでした。Braveサポートまでお問い合わせください。`)
};

/**
* | output |
* | --- |
* | "Whoops! It appears your order ID doesn't match your purchase receipt. Please contact Brave support." |
*
* @param {Order_Id_Mismatch_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const order_id_mismatch_error = /** @type {((inputs?: Order_Id_Mismatch_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Id_Mismatch_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_order_id_mismatch_error(inputs)
	if (locale === "ms") return ms_order_id_mismatch_error(inputs)
	if (locale === "ca") return ca_order_id_mismatch_error(inputs)
	if (locale === "cs") return cs_order_id_mismatch_error(inputs)
	if (locale === "da") return da_order_id_mismatch_error(inputs)
	if (locale === "de") return de_order_id_mismatch_error(inputs)
	if (locale === "et") return et_order_id_mismatch_error(inputs)
	if (locale === "es") return es_order_id_mismatch_error(inputs)
	if (locale === "fr") return fr_order_id_mismatch_error(inputs)
	if (locale === "hr") return hr_order_id_mismatch_error(inputs)
	if (locale === "it") return it_order_id_mismatch_error(inputs)
	if (locale === "lv") return lv_order_id_mismatch_error(inputs)
	if (locale === "lt") return lt_order_id_mismatch_error(inputs)
	if (locale === "hu") return hu_order_id_mismatch_error(inputs)
	if (locale === "nl") return nl_order_id_mismatch_error(inputs)
	if (locale === "nb") return nb_order_id_mismatch_error(inputs)
	if (locale === "pl") return pl_order_id_mismatch_error(inputs)
	if (locale === "pt") return pt_order_id_mismatch_error(inputs)
	if (locale === "ro") return ro_order_id_mismatch_error(inputs)
	if (locale === "sk") return sk_order_id_mismatch_error(inputs)
	if (locale === "sl") return sl_order_id_mismatch_error(inputs)
	if (locale === "fi") return fi_order_id_mismatch_error(inputs)
	if (locale === "sv") return sv_order_id_mismatch_error(inputs)
	if (locale === "vi") return vi_order_id_mismatch_error(inputs)
	if (locale === "tr") return tr_order_id_mismatch_error(inputs)
	if (locale === "el") return el_order_id_mismatch_error(inputs)
	if (locale === "bg") return bg_order_id_mismatch_error(inputs)
	if (locale === "ru") return ru_order_id_mismatch_error(inputs)
	if (locale === "sr") return sr_order_id_mismatch_error(inputs)
	if (locale === "uk") return uk_order_id_mismatch_error(inputs)
	if (locale === "ka") return ka_order_id_mismatch_error(inputs)
	if (locale === "hi") return hi_order_id_mismatch_error(inputs)
	if (locale === "th") return th_order_id_mismatch_error(inputs)
	if (locale === "ko") return ko_order_id_mismatch_error(inputs)
	if (locale === "zh") return zh_order_id_mismatch_error(inputs)
	if (locale === "zh-tw") return zh_tw_order_id_mismatch_error(inputs)
	if (locale === "ja") return ja_order_id_mismatch_error(inputs)
	return en_order_id_mismatch_error(inputs)
});